import React from 'react';

export default class BidAlertCard extends React.PureComponent {
	render() {
		const { className, onMakeBid, onRejectBid } = this.props;

		return (
			<div className={`card has-background-info-light ${className}`}>
				<div className="card-content is-flex is-align-items-center is-justify-content-space-between">
					<div className="is-flex is-align-items-center">
						<i className="fa fa-info has-text-info-dark mr-4" />
						<span className="has-text-info-dark has-text-weight-semibold">
							Would you like to place or decline a bid?
						</span>
					</div>
					<div className="buttons">
						<button className="button is-medium is-link" onClick={onMakeBid}>
							Make a bid
						</button>
						<button
							className="button is-medium has-text-weight"
							onClick={onRejectBid}
						>
							Decline to bid
						</button>
					</div>
				</div>
			</div>
		);
	}
}
